export const BANNER_MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
const EXPECTED_RATIO = 3;
const RATIO_TOLERANCE = 0.4;

type ValidationResult = { ok: true } | { ok: false; reason: 'ratio' };

export const validateBannerImage = (file: File): Promise<ValidationResult> =>
    new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(img.src);
            const ratio = img.width / img.height;
            if (Math.abs(ratio - EXPECTED_RATIO) > RATIO_TOLERANCE) {
                resolve({ ok: false, reason: 'ratio' });
            } else {
                resolve({ ok: true });
            }
        };
        img.onerror = () => {
            URL.revokeObjectURL(img.src);
            resolve({ ok: true });
        };
        img.src = URL.createObjectURL(file);
    });
